import { useQuery } from '@tanstack/react-query';
import { api } from '../api';
import { UserAPI } from '../../../../shared/types/api';

/**
 * Hook to fetch user's connections
 */
export function useConnections() {
  return useQuery({
    queryKey: ['connections'],
    queryFn: async (): Promise<UserAPI.GetConnectionsResponse> => {
      return api.get('/user/connections');
    },
  });
}

